import { __require as t } from "./KMHjDlmB.esm.js";
var e, r;
function u() {
  return r || (r = 1, e = t().style), e;
}
export {
  u as __require
};
